import React, { FormEvent, useContext, useEffect } from "react";
import { useState } from "react";
import {Grid,Tab,Form,Input,Select,Button,Table, Confirm, Header, Segment, GridColumn, Divider, Image, Dropdown} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import TextareaAutosize from "react-textarea-autosize";
import MinorStore from "../../../app/stores/minorStore";
import { IProjectTask } from "../../../app/models/projecttask";

const MinorTaskTab = () => {
  const minorStore = useContext(MinorStore);
  const {
    project,
    projecttasksByTime,
    loadProjectTasks,
    createProjectTask,
    deleteProjectTask,
    addProjectTask,
    updateTask,
    editProjectTask,
    techniciansByName,
    target,
    submitting,
  } = minorStore;

  useEffect(() => {
    loadProjectTasks(project!.id);
  }, []);

  const initialTaskForm: IProjectTask = {
    id: '',
    createdAt: '',
    updatedAt: '',
    projectId: project!.id,
    itemName: '',
    itemDescription: '',
    itemCategory: '',
    unitRate: 0,
    orderQty: 0,
    claimedQty: 0,
    currentValue: 0,
    paidValue: 0,
    status: 'Not Paid',
    remark: ''
  };

  const [projectTask, setProjectTask] = useState<IProjectTask>(initialTaskForm);
  const [openTask, setOpenTask] = useState(false);
  const [projecttaskId, setProjectTaskId] = useState("");

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    let total = projectTask.unitRate * projectTask.orderQty + Number(projectTask.claimedQty);
    switch(name) {
      case 'unitRate':
        total = Number(value) * projectTask.orderQty + Number(projectTask.claimedQty);
        break;
      case 'orderQty':
        total = Number(value) * projectTask.unitRate + Number(projectTask.claimedQty);
        break;
      case 'claimedQty':
        total = projectTask.unitRate * projectTask.orderQty + Number(value);
        break;
      default:
        break;
    }
    setProjectTask({ ...projectTask, [name]: value, ['currentValue']: total });
  };

  const technicianOptions = techniciansByName.map(function (tech) {
    var option = { "key": tech.email, "text": tech.name, "value": tech.email }
    return option;
  }
  );

  const paymentStatus = [
    { key: "Not Paid", text: "Not Paid", value: "Not Paid" },
    { key: "Partial Paid", text: "Partial Paid", value: "Partial Paid" },
    { key: "Paid", text: "Paid", value: "Paid" },
  ];

  function countTotal() {
    let total = 0;
    for (var i = 0; i < projecttasksByTime.length; i ++)
    {
      total = total + Number(projecttasksByTime[i].currentValue);
    }
    return total;
  };

  function countPaidTotal() {
    let total = 0;
    for (var i = 0; i < projecttasksByTime.length; i ++)
    {
      total = total + Number(projecttasksByTime[i].paidValue);
    }
    return total;
  };

  return (
    <Tab.Pane>
      <Header as='h3' textAlign='center' color='blue'>
      Work Orders
    </Header>
      <Table celled compact  >
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Item</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Unit Rate($)</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Quantity</Table.HeaderCell>
        <Table.HeaderCell>Technician</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Variation($)</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Total amount($)</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Paid Amount($)</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {projecttasksByTime.map((projecttask, index) => (
        (projecttask.itemCategory === 'new') ? 
        <Table.Row>
          <Table.Cell>
            <Input
              name="itemName"
              required
              onChange={handleInputChange}
              value={projectTask.itemName}
            />
          </Table.Cell>
          <Table.Cell >
          <Input
              name="unitRate"
              onChange={handleInputChange}
              type='number'
              value={projectTask.unitRate}
              style={{width: '90px'}}
            />
          </Table.Cell>
          <Table.Cell>
          <Input
              name="orderQty"
              onChange={handleInputChange}
              type='number'
              value={projectTask.orderQty}
              style={{width: '90px'}}
            />
          </Table.Cell>
          <Table.Cell>
          <Dropdown
            name="itemDescription"
            multiple
            search
            selection
            onChange={(e, { name, value }) => {
              setProjectTask({ ...projectTask, [name]: value });
            }}
            options={technicianOptions}
            value={projectTask.itemDescription}
            style={{minWidth: '120px'}}
          />
          </Table.Cell>
          <Table.Cell>
            <Input
              name="claimedQty"
              type='number'
              onChange={handleInputChange}
              value={projectTask.claimedQty}
              style={{width: '80px'}}
            />
            </Table.Cell>
          <Table.Cell textAlign='center'>
            {projectTask.currentValue}
          </Table.Cell>
          <Table.Cell>
          {/* <Form.Field
          control={TextareaAutosize}
          rows={1}
          onChange={(e: any) =>
              setProjectTask({ ...projectTask, ['remark']: e.currentTarget.value })
            }
          value={projectTask.remark}
          style={{border: '1px solid rgba(34,36,38,.15)'}}
        /> */}
        <Dropdown
            name="status"
            selection
            onChange={(e, { name, value }) => {
              setProjectTask({ ...projectTask, [name]: value });
            }}
            options={paymentStatus}
            value={projectTask.status}
            style={{minWidth: '120px'}}
          />
          {(projectTask.status !== 'Not Paid') && 
          <Input
              name="paidValue"
              type='number'
              onChange={handleInputChange}
              value={projectTask.paidValue}
              style={{width: '80px'}}
            />}
          </Table.Cell>
          <Table.Cell>
            <Button.Group size="mini">
              <Button
                size="mini"
                content="submit"
                color="green"
                onClick={() => createProjectTask(projectTask).then(() => setProjectTask(initialTaskForm))}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
        :
        
       <Table.Row key={projecttask.id}>
          <Table.Cell>
          <Input
              name="itemName"
              transparent
              onChange={(e, {name, value})=> updateTask(projecttask, name, value)}
              value={projecttask.itemName}
            />
          </Table.Cell>
          <Table.Cell>
          <Input
              name="unitRate"
              transparent
              onChange={(e, {name, value})=> updateTask(projecttask, name, value)}
              type='number'
              value={projecttask.unitRate}
              style={{width: '70px'}}
            />
          </Table.Cell>
          <Table.Cell>
          <Input
              name="orderQty"
              transparent
              onChange={(e, {name, value})=> updateTask(projecttask, name, value)}
              type='number'
              value={projecttask.orderQty}
              style={{width: '70px'}}
            />
          </Table.Cell>
          <Table.Cell>
          <Dropdown
            name="itemDescription"
            multiple
            search
            selection
            onChange={(e, {name, value})=> updateTask(projecttask, name, value)}
            options={technicianOptions}
            value={projecttask.itemDescription}
            style={{minWidth: '150px', border: 'none'}}
          />
          </Table.Cell>
          <Table.Cell>
          <Input
              name="claimedQty"
              transparent
              type='number'
              onChange={(e, {name, value})=> updateTask(projecttask, name, value)}
              value={projecttask.claimedQty}
              style={{width: '70px'}}
            />
          </Table.Cell>
          <Table.Cell textAlign='center'>{projecttask.currentValue}</Table.Cell>
          <Table.Cell>
          {/* <Form.Field
          control={TextareaAutosize}
          rows={1}
          onChange={(e: any)=> updateTask(projecttask, 'remark', e.currentTarget.value)}
          value={projecttask.remark}
          style={{border: 'none'}}
        /> */}
        <Dropdown
            name="status"
            selection
            onChange={(e, {name, value})=> {updateTask(projecttask, name, value);
                                            if (value === 'Not Paid') updateTask(projecttask, 'paidValue', '0')}}
            options={paymentStatus}
            value={projecttask.status}
            style={{minWidth: '120px', border: 'none'}}
          />
          {(projecttask.status !== 'Not Paid') && 
          <Input
              name="paidValue"
              type='number'
              transparent
              onChange={(e, {name, value})=> updateTask(projecttask, name, value)}
              value={projecttask.paidValue}
              style={{width: '80px'}}
            />}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <Button.Group size="mini">
           { (index === projecttasksByTime.length - 1) &&
              <Button
                size="mini"
                icon="add"
                color="green"
                title="Add new"
                onClick={() => addProjectTask()}
              />}
              <Button
                size="mini"
                icon="save"
                color="blue"
                title="Save changes"
                onClick={() => editProjectTask(projecttask)}
              />
              <Button
                name={projecttask.id}
                size="mini"
                onClick={() => {
                  setOpenTask(true);
                  setProjectTaskId(projecttask.id);
                }}
                icon="delete"
                color="red"
                title="Delete"
              />
              <Confirm
                open={openTask}
                onCancel={() => setOpenTask(false)}
                onConfirm={() => {
                  deleteProjectTask(projecttaskId);
                  setOpenTask(false);
                }}
                content="Are you sure you want to delete ?"
                confirmButton="Yes"
                size="mini"
                style={{
                  position: "relative",
                  maxHeight: "150px",
                  height: "auto",
                }}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
        
      ))}
    </Table.Body>
    <Table.Footer>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />         
          <Table.HeaderCell textAlign='right'>Total (excl. GST)</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>{countTotal().toFixed(2)}</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>{countPaidTotal().toFixed(2)}</Table.HeaderCell>
          <Table.HeaderCell />
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />         
          <Table.HeaderCell textAlign='right'>GST</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>{(countTotal()*(0.1)).toFixed(2)}</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />         
          <Table.HeaderCell textAlign='right'>Total (incl. GST)</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>{(countTotal()*(1.1)).toFixed(2)}</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Footer>
  </Table> 
    </Tab.Pane>
  );
};

export default observer(MinorTaskTab);
